export default __webpack_public_path__ + "static/media/11.14cb8761.png";